<app-admin-navbar></app-admin-navbar>

<div class="page">

  <div class="card">

    <h1>
      Edit Category
    </h1>

    <p *ngIf="loading">
      Loading category...
    </p>

    <div *ngIf="!loading">

      <div class="form-group">

        <label for="name">
          Name
        </label>

        <input
          id="name"
          name="name"
          type="text"
          [(ngModel)]="category.name"
          (ngModelChange)="onNameChange()"
        >

      </div>

      <div class="form-group">

        <label for="slug">
          Slug
        </label>

        <input
          id="slug"
          name="slug"
          type="text"
          [(ngModel)]="category.slug"
        >

      </div>

      <div class="form-group">

        <label for="image">
          Category Image
        </label>

        <input
          id="image"
          name="image"
          type="file"
          accept="image/*"
          (change)="onFileSelected($event)"
        >

      </div>

      <div
        class="image-preview"
        *ngIf="imagePreview"
      >

        <img
          [src]="imagePreview"
          alt="Category preview"
        >

      </div>

      <p *ngIf="uploading">
        Uploading image...
      </p>

      <p
        *ngIf="errorMessage"
        class="error"
      >
        {{ errorMessage }}
      </p>

      <button
        type="button"
        class="btn-save"
        [disabled]="saving || uploading"
        (click)="save()"
      >

        {{
          saving
            ? 'Saving...'
            : 'Update Category'
        }}

      </button>

    </div>

  </div>

</div>